import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import {
  DisputeReasonType,
  PublicInvoiceLinkStateType,
  RevealedInvoiceInstructionsType,
} from '@/types/invoiceVaultTypes';

export const openInvoiceLinkApi = (token: string): Promise<ApiResponseType<PublicInvoiceLinkStateType>> =>
  apiService.GET(`/invoice-links/${token}/`);
export const confirmInvoiceNumberApi = (
  token: string,
  invoice_number: string
): Promise<ApiResponseType<PublicInvoiceLinkStateType & { invoice_number: string }>> =>
  apiService.POST(`/invoice-links/${token}/confirm-number/`, { invoice_number });
export const reviewInvoiceApi = (
  token: string,
  payload: { decision: 'accept' | 'dispute'; reason?: DisputeReasonType; details?: string }
): Promise<ApiResponseType<PublicInvoiceLinkStateType>> => apiService.POST(`/invoice-links/${token}/review/`, payload);
export const revealInvoiceLinkApi = (token: string): Promise<ApiResponseType<RevealedInvoiceInstructionsType>> =>
  apiService.POST(`/invoice-links/${token}/reveal/`, {});
